import styled from "@emotion/styled";
import type { FC, ReactNode } from "react";

import { MDSText, MDSTextColor, MDSTextVariant } from "@/mds";

type Props = {
  tone?: "default" | "error";
  children: ReactNode;
};

export const InfoStatusMessage: FC<Props> = ({ tone = "default", children }) => (
  <Message
    variant={MDSTextVariant.TextSm}
    color={tone === "error" ? undefined : MDSTextColor.Secondary}
    $tone={tone}
  >
    {children}
  </Message>
);

const Message = styled(MDSText)<{ $tone: "default" | "error" }>`
  color: ${({ theme, $tone }) =>
    $tone === "error" ? theme.colors.text.danger : theme.colors.text.secondary};
`;
